module.exports = __webpack_public_path__ + "./docs/img/big-icon-root.30674b8ee7f4c18fcaecf951903989b4.svg";